module.exports = __webpack_public_path__ + "static/media/advasonic-toothbrush-head-5.f712a8d0.jpg";